module.exports = __webpack_public_path__ + "static/media/card-fries.c1ca76b0.png";